import React from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useInventorySituationModel } from "../inventorySituationModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { disableExportMsg } from "@/utils/exportFile";
// import { ResourceAuthEnum } from "@/types/ScmResourceAuthEnum";

export const DataBox = () => {
    const { exportInventorySituation } = useInventorySituationModel(() => []);

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.STT_ST_EX}> */}
        <Tooltip placement="topLeft" title={disableExportMsg}>
            <Button
                disabled={true}
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportInventorySituation()}
            >导出</Button>
        </Tooltip>
        {/* </YhAuth> */}
    </>;

    return (
        <YhBox title=" " action={action} style={{ height: 'calc(100vh - 200px)' }}>
            <DataTable />
        </YhBox>
    )
}